import { __extends } from "tslib";
import "./Badge.css";
import * as React from "react";
var Badge = (function (_super) {
    __extends(Badge, _super);
    function Badge() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Badge.prototype.render = function () {
        var type = this.props.type;
        return React.createElement("div", { className: "Badge Badge--" + type }, this.props.children);
    };
    Badge.defaultProps = {
        type: "default"
    };
    return Badge;
}(React.Component));
export default Badge;
export { Badge };
